module.exports = __webpack_public_path__ + "media/images/profile_small-f34d837c079759f1ee097e08fdeb7b30.jpg";